var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAmp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 98,
    viewBox: "0 0 98 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      boxShadow: "0px 4px 24px 0px rgba(0, 0, 0, 0.08)",
      borderRadius: 100
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 97,
    height: 97,
    rx: 48.5,
    fill: "white",
    stroke: "#EDEDF0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.9333 73.2613H42.8933L45.9013 55.0667L36.5947 55.08H36.4613C36.0596 55.0786 35.6747 54.9182 35.3909 54.6339C35.1071 54.3495 34.9474 53.9644 34.9467 53.5627C34.9467 53.2027 35.28 52.5947 35.28 52.5947L52.0053 24.7013L55.0987 24.7147L52.016 42.9387L61.3707 42.928H61.52C62.3573 42.928 63.0373 43.6053 63.0373 44.4427C63.0373 44.784 62.904 45.0827 62.7147 45.336L45.9333 73.2613ZM49 9C26.9093 9 9 26.9093 9 49C9 71.0907 26.9093 89 49 89C71.0933 89 89 71.0907 89 49C89 26.9093 71.0933 9 49 9Z",
    fill: "#046BE0"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmp);
export default __webpack_public_path__ + "static/media/amp.048368656bff0b63db9b4c82f49b9e92.svg";
export { ForwardRef as ReactComponent };